import React, { useEffect, useMemo } from "react";
import { Col, Divider, Row, Typography, Menu, Dropdown, Spin } from "antd";
import ComponentsBreadcrumb from "../../layout/componentsBreadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import AppText from "../../shared/appText";
import QRCodeComponent from "../shared.component/qrCodeComponent";
import { EmailShareButton, WhatsappShareButton } from "react-share";
import { useHistory, useParams } from "react-router-dom";
import NumberFormat from "react-number-format";
import { fetchPaymentDetails } from "../../reducers/paymentlinkReducer";
const { Title } = Typography;


const CreatePaymentInvoice = () => {
  const history = useHistory();
  const reducerDispatch = useDispatch();
  const {id,merchantName}=useParams()
  const paymentDetails = useSelector((state) => state.PayMentReducer.viewPaymentDetails);
  useEffect(() => {
    reducerDispatch(fetchPaymentDetails(id));
  }, [id]);// eslint-disable-line react-hooks/exhaustive-deps
  const breadCrumbList = useMemo(()=>{
    return [
      { id: "1", bname: "Payment Artha", url: '/dashboard' },
      { id: '2', bname: 'Payment Links', url: '/paymentlinks' },
      { id: '3', bname: merchantName, url: `/createpaymentlink/${id}/${paymentDetails?.data?.merchantName}?` },
      { id: '4', bname: paymentDetails?.data?.invoiceType }
    ];
  },[id,merchantName,paymentDetails]) 
  const redirectToCreatePaymentLink = () => {
    history.push(`/createpaymentlink/${id}/${paymentDetails?.data?.merchantName}?`)
  }
  const menu = (
    <Menu className="share-payment-link rounded-8">
      <ul className="dropdown-list margin-none">
        <Menu.Item className="rounded-5" onClick={redirectToCreatePaymentLink} >
          <div className="d-flex gap-8"><span className="icon md edit mb-2 edit-scale"></span>
            <span className="text-white">Edit</span></div>
        </Menu.Item>
      </ul>
    </Menu>
  );
  return (
    <>
      <ComponentsBreadcrumb breadCrumbList={breadCrumbList} />
      <div className="tracnsaction-details">
        {paymentDetails.isLoading ? (
          <div className="text-center">
            <Spin />
          </div>
        ) : (
          <div className='trans-card summary-content p-0 mb-30'>
            <div className="invoice-header">
              <div className="d-flex align-items-center" onClick={redirectToCreatePaymentLink}> <span className="icon lg btn-arrow-back c-pointer"></span>
                <Title className="mb-0 card-title" level={3}>{paymentDetails?.data?.invoiceType}</Title></div>
            </div>
            <Row gutter={[16, 16]} className="m-0 p-20 xs-block">
              <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                <div className=""><p className="invoice-name">{paymentDetails?.data?.merchantName}</p></div>
                <AppText className="invoice-btc"><AppText className="invoice-btc">
                  <NumberFormat value={paymentDetails?.data?.isPayCommission
                    ? (parseFloat(paymentDetails?.data?.amount) +
                      parseFloat(((parseFloat(paymentDetails?.data?.amount || 0) / 100) *
                        parseFloat(paymentDetails?.data?.commission || 0)))).toFixed(4)
                    : parseFloat(paymentDetails?.data?.amount).toFixed(4)}
                    displayType="text" thousandSeparator={true} thousandsGroupStyle="lakh" />

                  {" "}  {paymentDetails?.data?.currency}
                </AppText>
                </AppText>
                {paymentDetails?.data?.amountInUsd &&
                  <p className="invoice-text mb-4">
                    <NumberFormat value={paymentDetails?.data?.amountInUsd} displayType="text" thousandSeparator={true} thousandsGroupStyle="lakh" /> USD</p>}
                {/* {paymentDetails?.data?.isPayCommission && 
              <p className="invoice-text mb-4"><span className="invoice-label">Fee : </span>
              <NumberFormat value={paymentDetails?.data?.isPayCommission ? (((parseFloat(paymentDetails?.data?.amount || 0) / 100) * parseFloat(paymentDetails?.data?.commission || 0)).toFixed(4)) : 0} displayType="text" thousandSeparator={true} thousandsGroupStyle="lakh"/>  {" "}  {paymentDetails?.data?.currency}</p> } */}
                <p className="invoice-text mb-4"><span className="invoice-label">Network :</span>  {paymentDetails?.data?.networkName}</p>
                <p className="invoice-label">Order ID : <CopyToClipboard text={paymentDetails?.data?.orderId} options={{ format: 'text/plain' }}><AppText copyable={{ tooltips: ['Copy', 'Copied'] }} className="invoice-text">{paymentDetails?.data?.orderId || "--"}</AppText></CopyToClipboard></p>
              </Col>

              <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                <div className="d-flex align-items-center gap-8 mb-16">
                  <span className="icon lg info-icon"></span>
                  <p className="text-white">You pay network fee</p>

                  <Dropdown placement="topLeft" overlay={menu} className="" overlayClassName="paylinks-dropdown" >
                    <a className="d-flex align-items-center">
                      <span className="icon lg settings-icon c-pointer" ></span>
                    </a>
                  </Dropdown>
                </div>
                <div className="" >
                  <QRCodeComponent size={200} value={paymentDetails?.data?.walletAddress} />
                </div>
                <p className="invoice-label">Recepient's wallet address</p>
                <CopyToClipboard text={paymentDetails?.data?.walletAddress} options={{ format: 'text/plain' }}><AppText copyable={{ tooltips: ['Copy', 'Copied'] }} className="invoice-text">{paymentDetails?.data?.walletAddress?.slice(0, 12)}...{paymentDetails?.data?.walletAddress?.slice(-3)}</AppText></CopyToClipboard>
                <p className="invoice-label">When your payment status will change, we'll send to you notification</p>
              </Col>
            </Row>
            <div className="p-20 pt-0">
              <Divider plain className="text-white">OR</Divider>
              <p className="address-share text-center mb-4">Share it on</p>
              <div className="d-flex share-icons">
                <Menu className="share-adrs text-center">
                  <Menu.Item>
                    <WhatsappShareButton url={`${paymentDetails?.data?.paymentLink} \nThank you.`}
                      title={`Hello, I would like to share my ` + `${paymentDetails?.data?.currency} ` + `(${paymentDetails?.data?.networkName}) ` + ` address for receiving: ` + `\n${paymentDetails?.data?.walletAddress}` + `\nPlease make sure you are using the correct protocol otherwise you are risking losing the funds.\nI am using Payment Gateway:`} >
                      <span className='icon lg whatsapp'></span>
                    </WhatsappShareButton>
                  </Menu.Item>
                  <Menu.Item>
                    <EmailShareButton te url={`${paymentDetails?.data?.paymentLink} \nThank you.`} subject={"Wallet Address"} body={`Hello, I would like to share my ` + `${paymentDetails?.data?.currency} ` + `(${paymentDetails?.data?.networkName}) ` + ` address for receiving: ` + `\n${paymentDetails?.data?.walletAddress}` + `\nPlease make sure you are using the correct protocol otherwise you are risking losing the funds.\nI am using Payment Gateway:`}> <span className='icon lg mail'></span></EmailShareButton>
                  </Menu.Item>
                </Menu>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CreatePaymentInvoice;
